function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 24.5,
  cy: 24.5,
  r: 23,
  stroke: "currentColor",
  strokeWidth: 3
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 13.5,
  cy: 21.5,
  r: 3.5,
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 35.5,
  cy: 21.5,
  r: 3.5,
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5891 31.9117C16.0856 31.6848 15.8614 31.0927 16.0883 30.5892C16.3152 30.0857 16.9074 29.8614 17.4109 30.0884L16.5891 31.9117ZM31.81 30.0536C32.3327 29.8753 32.901 30.1546 33.0792 30.6773C33.2575 31.2 32.9782 31.7683 32.4555 31.9465L31.81 30.0536ZM17.4109 30.0884C22.3047 32.2939 26.5209 31.8571 31.81 30.0536L32.4555 31.9465C26.902 33.8402 22.1182 34.4035 16.5891 31.9117L17.4109 30.0884Z",
  fill: "currentColor"
});

function SvgSmiley3Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley3Icon);
export default __webpack_public_path__ + "static/media/Smiley3Icon.90b3751b.svg";
export { ForwardRef as ReactComponent };